/**
 * Created by AInfante on 05/10/16.
 */

// PositionSearchDetailView.js
import $ from 'jquery';
import _ from 'lodash';
import { View } from 'backbone';

import constants        from 'Constants.js';
import contentTemplate  from 'dashboard/settings/positions-view.ejs';
import BaseTableView from 'properties/BaseTableView.js'
import util from 'util/Util.js';
import RestService from 'RestService.js';
import eventBus         from 'EventBus.js';

class PositionSearchDetailView  extends BaseTableView  {
    initialize(opts) {

        this.options = opts || {};
        this.template = contentTemplate;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.events = {
            'change input[type="text"],select ':'updateFilters',
            'click #view-position':'viewPositionDetails',
            'click #goToSettings': 'goToSettings',
            'click #goToAccountSettings': 'goToAccountSettings'
        };

        this.model.set({
            colModel: [
                {
                    name: 'PositionId',
                    index: 'PositionId',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'Name',
                    index: 'Name',
                    editable: false
                }

            ],
            colNames: ['PositionId','Name']
        });

        this.listenTo(this.model, 'change', this.render);
        this.onResize();
        return this;
    }

     // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
     onResize(){
        $(window).bind('resize',() => {this.resizeGrid();})
    }

    updateFilters(event){
        // Saving search values inside the model, so the search can be preserved on renders.
        const targetValue = event.target.value;
        this.model.set('search-' + event.target.name, targetValue, {silent:true});
        this.performSearch();
    }

    onCellSelect(rowId, iCol, cellContent,e){
        $(this.gridEl).jqGrid('setSelection',rowId);
        if(cellContent=== '&nbsp;'){
            return;
        }
        $("#view-position").prop('disabled',false);
    }

    ondblClickRow(rowId){
        this.switchToPositionDetails(rowId);
    }

    viewPositionDetails(event){
        event.preventDefault();
        let selRowId = $(this.gridEl).jqGrid('getGridParam', 'selrow');
        this.switchToPositionDetails(selRowId);
    }

    switchToPositionDetails(selectedRow){
        let rowData = $(this.gridEl).getRowData(selectedRow);
        let positionIdToOpen = rowData['PositionId'];
        if(positionIdToOpen === ''){
            return;
        }
        const eventValues={
            detailPage: 'PositionDetailsView',
            payload:{
                positionId: positionIdToOpen
            }
        };
        eventBus.trigger(constants.SWITCH_DETAIL_POSITION, eventValues);
    }

    performSearch(){
        // Adding the '%' wildcard to the input text searches if any, requested by the API.
        const positionName = this.model.get('search-positionName') ? this.model.get('search-positionName') + '%' : '%';

        RestService.searchPositions(positionName).then((positionData)=>{
            this.model.set('totalRecords',positionData.TotalRecords,{silent:true});
            if(positionData.Positions) {
                let positions = positionData.Positions.Position instanceof Array
                    ? positionData.Positions.Position
                    : [positionData.Positions.Position];
                this.model.set('gridData', positions, {silent: true});
            }
            else{
                this.model.set('gridData', [], {silent: true});
            }

            let breadcrumbs = [
                {name: 'Settings', route: '#settings', id: 'goToSettings'},
                {name: 'Account Settings', id: 'goToAccountSettings'},
                {name: 'General Position Information', route: '#generalPositionInformation'}
            ];

            this.model.set('dashboardTitle', 'Positions');
            this.model.set('breadcrumbs', breadcrumbs);
            this.render();
        });
    }

    render() {
        this.onRender();
        var gridData = this.model.get('gridData');

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        var self = this;
        let gridObject=util.getGridObject(self,{autowidth:true,scrollOffset:0});
        $(self.gridEl).jqGrid(gridObject);

        if(gridData) {
            gridData.forEach(function (value, index) {
                if (value){
                    var newRow = {
                        'PositionId': value['@id'],
                        'Name': value['@name']
                    };
                    $(self.gridEl).addRowData(index, newRow);
                }
            });
        }

        if(gridData.length < 10){
            for(let i = 0; i < 10 - gridData.length; i++){
                var newRow = {
                    'PositionId': '',
                    'Name': ''
                };
                $(self.gridEl).addRowData(gridData.length + i, newRow);
            }
        }

        $('#detailHeading').html('Settings - Dashboard');

        this.resizeGrid();
        this.delegateEvents();

        this.afterRender();
        this.$el.css('cursor', 'default');
        $('.ui-jqgrid-bdiv').css('max-height','242px');

        return this;
    }

    remove(){
        $(window).unbind('resize');
        super.remove();
    }

    goToSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger('loadSettingsView');
    }

    goToAccountSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        $('div.document-heading > a[data-target="#well_1"]').click();
    }
}

export default PositionSearchDetailView;
